export default __webpack_public_path__ + "static/howItWorksCard1-d8634adfbdc2089089981f66a30575ae.png";